/* LEGEND — Ride draft enhancements.
   Namespaced, additive, and safe to delete. Nothing here is required for the
   page to function: every behaviour degrades to the theme's default.
   1. Hero video: accessible pause/play control.
   2. Product titles: presentation-layer split so the long spec tail becomes
      secondary detail instead of wrapping the heading over five lines.
   Product data, handles and titles are NOT modified. This is display only. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Hero video pause / play ---------- */
  function heroControls() {
    var video = document.querySelector('.vh-video');
    var inner = document.querySelector('.vh-inner');
    if (!video || !inner || document.querySelector('.lg-vh-toggle')) return;
    // Nothing to control if the video was suppressed on small screens.
    if (video.getAttribute('data-lg-suppressed') === 'true') return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lg-vh-toggle';

    function paint() {
      var paused = video.paused;
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      btn.textContent = paused ? 'Play' : 'Pause';
    }

    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
      paint();
    });
    video.addEventListener('play', paint);
    video.addEventListener('pause', paint);

    paint();
    inner.appendChild(btn);
  }

  /* ---------- 2. Product title split ---------- */
  // "Pro Series V2 Ringed — Steel Tip 90% Tungsten"
  //   -> "Pro Series V2 Ringed" + secondary "Steel Tip 90% Tungsten"
  // Only splits on an em dash with spaces around it, which is the house
  // convention for "name — spec". Titles without it are left completely alone,
  // so player names, ranges, models and finishes are never stripped.
  var SPLIT = /^([\s\S]+?)\s+—\s+([\s\S]+)$/;

  function splitOne(el) {
    if (!el || el.getAttribute('data-lg-split') === 'true') return;
    // Only operate when the element holds plain text, so we never destroy
    // nested markup such as badges or the card's unstyled link wrapper.
    var target = el;
    var link = el.querySelector('a');
    if (link && link.children.length === 0) target = link;
    if (target.children.length > 0) return;

    var raw = target.textContent.replace(/\s+/g, ' ').trim();
    var m = raw.match(SPLIT);
    if (!m) { el.setAttribute('data-lg-split', 'true'); return; }

    target.textContent = m[1];
    var span = document.createElement('span');
    span.className = 'lg-title-sub';
    span.textContent = m[2];
    target.appendChild(span);
    el.setAttribute('data-lg-split', 'true');
  }

  function titles(root) {
    var scope = root || document;
    var sel = '.card__heading, .product__title h1, .product__title h2';
    var nodes = scope.querySelectorAll ? scope.querySelectorAll(sel) : [];
    for (var i = 0; i < nodes.length; i++) splitOne(nodes[i]);
  }

  function init() {
    heroControls();
    titles(document);

    // Re-run for content the theme swaps in: filtering, pagination,
    // quick add, variant changes and the cart drawer.
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        titles(document);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Keep the hero paused from the start when the visitor asks for less motion.
  if (REDUCED) {
    document.addEventListener('DOMContentLoaded', function () {
      var v = document.querySelector('.vh-video');
      if (v) { try { v.pause(); } catch (e) {} }
    });
  }
})();
